import React from 'react';

import {
  HighlightBox,
  SectionHeader,
  StatsCard,
  Subsection,
  SuccessBox,
  TabSection,
  WarningBox,
} from './_shared';

function Presentation() {
  return (
    <div>
      <TabSection>
        <SectionHeader title={<span>POURQUOI UN RÉFÉRENT MUTATION LOCATION ?</span>} />
        <p style={{ fontSize: '1.05rem', marginBottom: '20px' }}>
          La désignation d'un référent mutation location permet d'avoir une personne qui peut parler de transaction ou de location avec des copropriétaires sans que le syndic tombe dans le détournement de finalité.
        </p>
        <HighlightBox variant="info">
          <strong><span role="img" aria-label="emoji">⚖</span>️ Objectif principal :</strong> Éviter un détournement de finalité des données personnelles
        </HighlightBox>
      </TabSection>

      <TabSection>
        <SectionHeader title={<span><span role="img" aria-label="magnifying glass">🔍</span> A. LE DÉTOURNEMENT DE FINALITÉ : EXPLICATION</span>} />
        <Subsection>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Un syndic de copropriété collecte des informations personnelles auprès des copropriétaires pour une finalité bien précise : <strong>gérer la copropriété</strong>.
          </p>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Selon le principe posé par le RGPD (article 5.1.b), les données personnelles ne peuvent pas être traitées ultérieurement pour des finalités différentes.
          </p>
        </Subsection>

        <WarningBox title={(
          <span><span role="img" aria-label="emoji">⚠</span>️ Finalités interdites</span>
        )}>
          <p style={{ marginBottom: '12px' }}>
            Il y a détournement de finalité quand le syndic utilise les données perso destinées à la gestion de la copropriété afin de proposer des services commerciaux comme :
          </p>
          <ul style={{ marginLeft: '25px' }}>
            <li style={{ marginBottom: '10px' }}>Des services de transaction immobilière</li>
            <li style={{ marginBottom: '10px' }}>Des services de location immobilière</li>
            <li style={{ marginBottom: '10px' }}>La promotion d'offres de gestion locative</li>
          </ul>
        </WarningBox>

        <Subsection>
          <h4 style={{ color: '#1e293b', fontSize: '1.2rem', fontWeight: 700, marginBottom: '15px' }}><span role="img" aria-label="emoji">⚖</span>️ Sanctions pénales (Article 226-21 du Code pénal)</h4>
          <p style={{ marginBottom: '15px' }}>(il y a aussi les sanctions administratives et parfois civiles)</p>
          <p style={{ marginBottom: '15px' }}>
            En cas de détournement de finalité, plusieurs types de sanctions sont encourues, notamment des sanctions pénales :
          </p>
          <ul style={{ marginLeft: '25px' }}>
            <li style={{ marginBottom: '10px' }}><strong>Amende :</strong> Jusqu'à 300 000 euros</li>
            <li style={{ marginBottom: '10px' }}><strong>Peine de prison :</strong> Jusqu'à 5 ans d'emprisonnement</li>
          </ul>
        </Subsection>

        <StatsCard value={<><span role="img" aria-label="emoji">⚖</span>️ 300 000 €</>} label="Amende maximale en cas de détournement" />
        <StatsCard value={<><span role="img" aria-label="emoji">⚖</span>️ 5 ans</>} label="Peine de prison maximale" />
      </TabSection>

      <TabSection>
        <SectionHeader title={<span><span role="img" aria-label="check mark">✅</span> B. LA NOMINATION D'UN RÉFÉRENT MUTATION LOCATION ÉCARTE LE RISQUE</span>} />
        <Subsection>
          <p style={{ marginBottom: '15px' }}>
            La nomination d'un référent mutation location écarte le risque d'un détournement de finalité si :
          </p>
          <ul style={{ marginLeft: '25px' }}>
            <li style={{ marginBottom: '10px' }}>Les informations données par ce référent aux copropriétaires entrent uniquement dans le cadre de la mission de conseil du syndic</li>
            <li style={{ marginBottom: '10px' }}>Il maîtrise les principes du RGPD pour adapter ses propos à l'attention des copropriétaires – (il passe une certification)</li>
            <li style={{ marginBottom: '10px' }}>S'il est seulement l'interface entre le copropriétaire et les services de transaction et/ou de location en obtenant préalablement le consentement du copropriétaire à cette mise en relation</li>
          </ul>
        </Subsection>
        <SuccessBox title={(
          <span><span role="img" aria-label="check mark">✅</span> Le référent est donc un intermédiaire</span>
        )}>
          <p>
            Il assure la liaison entre les copropriétaires et les services de transaction et/ou de gestion locative si le copropriétaire le souhaite et cela dans le respect du RGPD
          </p>
        </SuccessBox>
      </TabSection>
    </div>
  );
}

export default Presentation;


